import axios from "../utils/axios";

export const postBreakdownDetailExcelToList = (payload) => {
    return axios.post(`/BreakdownReasonDetail/ExcelToList`, payload);
};

export const postBreakdownDetailExcelUpload = (payload) => {
    return axios.post(`/BreakdownReasonDetail/TranslationsExcel`, payload);
};

export const downloadBreakdownDetailExcel = () => {
    return axios.get(`/BreakdownReasonDetail/TranslationsExcel`, {
        responseType: "blob",
    });
};

export const postBreakdownEffectExcelToList = (payload) => {
    return axios.post(`/BreakdownEffect/ExcelToList`, payload);
};

export const postBreakdownEffectExcelUpload = (payload) => {
    return axios.post(`/BreakdownEffect/TranslationsExcel`, payload);
};

export const downloadBreakdownEffectExcel = () => {
    return axios.get(`/BreakdownEffect/TranslationsExcel`, {
        responseType: "blob",
    });
};

export const postBreakdownReasonGroupExcelToList = (payload) => {
    return axios.post(`/BreakdownReasonGroup/ExcelToList`, payload);
};

export const postBreakdownReasonGroupExcelUpload = (payload) => {
    return axios.post(`/BreakdownReasonGroup/TranslationsExcel`, payload);
};

export const downloadBreakdownReasonGroupExcel = () => {
    return axios.get(`/BreakdownReasonGroup/TranslationsExcel`, {
        responseType: "blob",
    });
};

export const postBreakdownReasonPlaceExcelToList = (payload) => {
    return axios.post(`/BreakdownReasonPlace/ExcelToList`, payload);
};

export const postBreakdownReasonPlaceExcelUpload = (payload) => {
    return axios.post(`/BreakdownReasonPlace/TranslationsExcel`, payload);
};

export const downloadBreakdownReasonPlaceExcel = () => {
    return axios.get(`/BreakdownReasonPlace/TranslationsExcel`, {
        responseType: "blob",
    });
};

export const postBreakdownRootCauseExcelToList = (payload) => {
    return axios.post(`/BreakdownRootCause/ExcelToList`, payload);
};

export const postBreakdownRootCauseExcelUpload = (payload) => {
    return axios.post(`/BreakdownRootCause/TranslationsExcel`, payload);
};

export const downloadBreakdownRootCauseExcel = () => {
    return axios.get(`/BreakdownRootCause/TranslationsExcel`, {
        responseType: "blob",
    });
}
